export enum PresetTimeRange {
  REAL_TIME = 'Real-Time',
  LAST_HOUR = 'Last hour',
  LAST_DAY = 'Last day',
  LAST_WEEK = 'Last week',
  LAST_MONTH = 'Last month',
  LAST_YEAR = 'Last year',
  CUSTOM = 'Custom',
}
